<template>
        <client-page>
            <form-mail></form-mail>
        </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import MainHeader from "@/components/client/ko/inc/main-header.vue";
import FormMail from "@/components/client/ko/demo/form-mail.vue"
export default {
    components: {
        MainHeader,
        FormMail,
        ClientPage
    }
};
</script>
